export const sxConfig = {
  box: {
    position: 'fixed',
    bottom: 80,
    right: 20,
    width: '800px',
    height: '600px',
    bgcolor: 'background.paper',
    boxShadow: 3,
    p: 2,
    borderRadius: 2,
    zIndex: 100,
  },
  fab: {
    position: 'fixed',
    bottom: 15,
    right: 15,
    width: 30,
    height: 30,
  },
};
